

































































import { Component, Vue } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';

// Services
import Staff from '@/services/Staff';
import * as Sentry from '@sentry/browser';
import Offbase from '@/services/Offbase'; // Was "Claims"

// Components
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import Assignee from '@/components/Staff/Claims/Assignee.vue'; // TODO: change to OffbaseDocument

@Component({
	name: 'PageStaffOffbase',
	components: {
		Loading,
		Alert,
		Assignee,
	},
})
export default class OffbaseList extends Vue {
	private claims: any;
	private allClaims: any;
	private showAllClaims: boolean;
	private error: boolean;
	private loading: boolean;
	private paginate: string[];

	constructor() {
		super();

		this.claims = [];
		this.allClaims = [];
		this.showAllClaims = false;
		this.error = false;
		this.loading = true;
		this.paginate = ['claims'];
	}

	private openClaim(id) {
		this.$router.push({
			name: 'staffoffbasedocument',
			params: {
				id,
			},
		});
	}

	private uploadDocument() {
		this.$router.push({
			name: 'staffoffbasedocupload',
			params: {},
		});
	}

	private showAll() {
		this.showAllClaims = true;
		this.claims = this.allClaims;
	}

	private filterClaims() {
		this.showAllClaims = false;
		this.claims = this.claims.filter(claim => !('setup' in claim) || claim.setup === 'false');
	}

	private async created() {
		try {
			// Get Offbase Documents
			const getClaims = await Staff.getOffbaseDocuments();

			if (getClaims.data.length > 0) {
				this.claims = getClaims.data;
				this.claims.map(o => {
					if (o.hasOwnProperty('data')) {
						o.name = o.data.name;
					} else {
						o.name = o.email;
					}

					o.claim_status = Offbase.getClaimStatus(o);

					return o;
				});

				this.allClaims = cloneDeep(this.claims);

				this.claims = this.claims.filter(
					claim => !('setup' in claim) || claim.setup === 'false',
				);
			}
		} catch (e) {
			Sentry.captureException(e);
			this.error = true;
		} finally {
			this.loading = false;
		}
	}
}
